import { render, staticRenderFns } from "./serviceForm.vue?vue&type=template&id=22317b71&scoped=true"
import script from "./serviceForm.vue?vue&type=script&lang=js"
export * from "./serviceForm.vue?vue&type=script&lang=js"
import style0 from "./serviceForm.vue?vue&type=style&index=0&id=22317b71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22317b71",
  null
  
)

export default component.exports